import {
  DEBIT_NOTE_DELETE_ACTION_TYPE,
  DEBIT_NOTE_DETAILS_ACTION_TYPE,
  DEBIT_NOTE_DETAILS_ORDER_ACTION_TYPE,
  DEBIT_NOTE_DOWNLOAD_ACTION_TYPE,
  DEBIT_NOTE_IE_ACTION_TYPE,
  DEBIT_NOTE_LIST_ACTION_TYPE,
} from "../../utils/constants";

const initialState = [];

function accountDebitNoteReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case DEBIT_NOTE_LIST_ACTION_TYPE:
      return [...state, payload];
    case DEBIT_NOTE_DETAILS_ACTION_TYPE:
      return [...state, payload];
    case DEBIT_NOTE_DETAILS_ORDER_ACTION_TYPE:
      return [...state, payload];
    case DEBIT_NOTE_IE_ACTION_TYPE:
      return [...state, payload];
    case DEBIT_NOTE_DELETE_ACTION_TYPE:
      return [...state, payload];
    case DEBIT_NOTE_DOWNLOAD_ACTION_TYPE:
      return [...state, payload];
    default:
      return state;
  }
}

export default accountDebitNoteReducer;
